import "./ProductsContainer.css"
import React from "react";
import ProductContainer from "../ProductContainer/ProductContainer";
import {useTranslation} from "react-i18next";


export default function ProductsContainer({product, pickAddons}) {
    const {t} = useTranslation();
    if(!product?.length) {
        return (<span style={{alignSelf: "center"}}>
            {t("pickAddonNoAddonsAvailable")}
        </span>)
    }
    return (
        <>
            <div className={"pickaddon-product-wrapper"}>
                {product.map((product, index) => {
                    return (
                        <ProductContainer key={index} product={product} pickAddons={pickAddons}/>
                    )
                })}
            </div>
        </>
    )
}